import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import './Orders.css';

const Orders: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const trendingCategories = [
    { name: "Safety", image: "/assets/images/torch_light.png" },
    { name: "Machine", image: "/assets/images/sewing_machine.png" },
    { name: "Generator", image: "/assets/images/air_compressor.png" },
    { name: "Camera", image: "/assets/images/camera.png" },
    { name: "Cleaner", image: "/assets/images/vacuum_cleaner.png" },
    { name: "Stove", image: "/assets/images/induction_cooktop.png" }
  ];

  // Retrieve user orders from local storage in real-time
  const ordersStr = localStorage.getItem('user_orders');
  const allOrders = ordersStr ? JSON.parse(ordersStr) : [];
  
  const userEmail = user?.email || 'guest@industrybull.com';
  let userOrders = allOrders.filter((order: any) => order.userEmail === userEmail);


  const fullName = user ? `${user.firstName} ${user.lastName}` : 'Guest User';

  return (
    <div className="account-orders-page">
      <div className="account-orders-container">
        
        <div className="account-layout">
          
          {/* Sidebar */}
          <aside className="account-sidebar-panel">
            <div className="account-user-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="user-icon">
                <path d="M20 21a8 8 0 0 0-16 0"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              {fullName}
            </div>
            <nav className="account-nav-list">
              <Link to="/account/addresses" className="account-nav-item">
                <span className="icon">⌖</span> My Addresses
              </Link>
              <Link to="/account/orders" className="account-nav-item active">
                <span className="icon green-icon">▣</span> My Order
              </Link>
              <Link to="/account/rfqs" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span> My RFQ's
              </Link>
              <Link to="/account/business" className="account-nav-item">
                <span className="icon">▤</span> My Business Details
              </Link>
              <Link to="/account/wishlist" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span> My Wishlist
              </Link>
              <Link to="/logout" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span> Log-out
              </Link>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="account-main-content">
            
            {userOrders.length > 0 ? (
              <div className="orders-list-container" style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '30px' }}>
                <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#1e293b', margin: '0 0 10px 0', borderBottom: '2px solid #df2027', paddingBottom: '8px', display: 'inline-block' }}>My Placed Orders</h2>
                {userOrders.map((order: any) => (
                  <div key={order.orderId} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.04)' }}>
                    <div style={{ background: '#f8fafc', padding: '16px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '15px', alignItems: 'center' }}>
                      <div style={{ display: 'flex', gap: '30px' }}>
                        <div>
                          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Date Placed</div>
                          <div style={{ fontSize: '14px', color: '#334155', fontWeight: '600', marginTop: '4px' }}>{order.date}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Total Amount</div>
                          <div style={{ fontSize: '14px', color: '#df2027', fontWeight: '750', marginTop: '4px' }}>₹{parseFloat(order.total).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Billing To</div>
                          <div style={{ fontSize: '14px', color: '#334155', fontWeight: '600', marginTop: '4px' }}>{order.shippingDetails?.firstName} {order.shippingDetails?.lastName}</div>
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Order ID</div>
                        <div style={{ fontSize: '14px', color: '#1e293b', fontWeight: '800', marginTop: '4px' }}>{order.orderId}</div>
                      </div>
                    </div>
                    
                    <div style={{ padding: '24px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px dashed #e2e8f0', paddingBottom: '12px' }}>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#475569' }}>
                          Status: <span style={{ color: order.status === 'Delivered' ? '#16a34a' : order.status === 'Shipped' ? '#2563eb' : '#d97706', background: order.status === 'Delivered' ? '#f0fdf4' : order.status === 'Shipped' ? '#eff6ff' : '#fffbeb', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', marginLeft: '8px', border: '1px solid currentColor' }}>{order.status}</span>
                        </span>
                        {order.shippingDetails?.address && (
                          <span style={{ fontSize: '12px', color: '#64748b' }}>Delivery Address: {order.shippingDetails.address}, {order.shippingDetails.city}</span>
                        )}
                      </div>
                      
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {order.items.map((item: any, idx: number) => (
                          <div key={idx} style={{ display: 'flex', gap: '18px', alignItems: 'center' }}>
                            <div style={{ width: '64px', height: '64px', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '6px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <img src={item.image} alt={item.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                            </div>
                            <div style={{ flex: '1' }}>
                              <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b', margin: '0 0 6px 0', lineHeight: '1.4' }}>{item.name}</h4>
                              <p style={{ fontSize: '12px', color: '#64748b', margin: 0 }}>Quantity: <strong>{item.quantity}</strong> | Unit Price: ₹{item.price}</p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <span style={{ fontSize: '15px', fontWeight: '800', color: '#1e293b' }}>₹{item.price * item.quantity}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              /* Empty Orders Banner */
              <div className="empty-orders-banner">
                <div className="empty-orders-image-container">
                  <img src="/assets/images/order-confirmed.png" alt="Empty Orders" />
                </div>
                <div className="empty-orders-details">
                  <h2>Your cart is empty and sad</h2>
                  <p>Add something to make it happy!</p>
                  <button className="start-shopping-btn" onClick={() => navigate('/')}>
                    Continue Shopping
                  </button>
                </div>
              </div>
            )}

            {/* Trending Categories Section */}
            <div className="orders-trending-categories">
              <h3>Trending Categories</h3>
              <div className="trending-categories-grid">
                {trendingCategories.map((cat, idx) => (
                  <div key={idx} className="trending-category-square-card">
                    <div className="trending-img-box">
                      <img src={cat.image} alt={cat.name} />
                    </div>
                    <div className="trending-name-box">
                      <span>{cat.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </main>
        </div>
      </div>
    </div>
  );
};

export default Orders;
